<mat-dialog-content>
    <p>Ingresá tu DNI para continuar:</p>
    <mat-form-field appearance="outline" class="w-full">
        <mat-label>DNI</mat-label>
        <input matInput [ngModel]="dni" (ngModelChange)="onDniInput($event)" />
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="loginClick.emit()">Iniciar sesión</button>
    <button mat-flat-button color="primary" (click)="continuarClick.emit(dni)">Continuar</button>
</mat-dialog-actions>